function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 21.413c-5.224 5.223-9.701 0-9.701 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.985 17.287c0 1.018-1.454 2.686-2.835 2.686-1.382 0-2.836-1.668-2.836-2.686 0-1.019 1.454-1.844 2.836-1.844 1.381 0 2.835.825 2.835 1.844z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.97 12.831a1.492 2.612 0 11-2.984 0 1.492 2.612 0 112.985 0z",
  strokeWidth: 0.9999482,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.97 12.906a.746.746 0 11-1.492 0 .746.746 0 111.493 0zM32.313 12.831a1.492 2.612 0 11-2.985 0 1.492 2.612 0 112.985 0z",
  strokeWidth: 0.9999482,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.313 12.906a.746.746 0 11-1.492 0 .746.746 0 111.492 0z",
  strokeWidth: 0.9999482,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.462 14.697c0 7.006-5.512 12.686-12.312 12.686s-12.313-5.68-12.313-12.686S18.349 2.01 25.15 2.01c6.8 0 12.312 5.68 12.312 12.686z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.33 8.727c-2.061 0-4.478-2.417-4.478-4.477 0-2.061 1.67-3.732 3.731-3.732 2.06 0 3.731 2.417 3.731 4.478M36.044 8.727c2.061 0 4.478-2.417 4.478-4.477 0-2.061-1.67-3.732-3.731-3.732S33.06 2.935 33.06 4.996M31 26c4.85 1.7 8 6.193 8 10.7a8.92 8.92 0 01-.198 1.869M29.6 47.5c-4 2-6.739.074-7.86-.161M11 38c0-4.634 3.93-10.38 9-12",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.916 42.675c3.243 3.767 4.176 8.28 2.084 10.083-2.092 1.802-6.418.21-9.662-3.557-3.243-3.766-4.177-8.28-2.084-10.082 2.092-1.802 6.418-.21 9.662 3.556zM32.338 42.675c-3.243 3.767-4.177 8.28-2.084 10.083 2.092 1.802 6.418.21 9.662-3.557 3.243-3.766 4.176-8.28 2.084-10.082-2.092-1.802-6.418-.21-9.662 3.556z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18 27c-3 1-4.23 4.383-7.507 5.847C9.093 33.473 7.21 34.983 6 35c-1.622.022-2.418-1.687-2.87-2.697-.788-1.765 1.23-4.383 4.508-5.847C10.915 24.99 17.212 25.236 18 27zM32.96 27c3 1 4.23 4.383 7.507 5.847 1.4.626 3.283 2.136 4.493 2.153 1.622.022 2.418-1.687 2.87-2.697.788-1.765-1.23-4.383-4.508-5.847-3.277-1.465-9.573-1.22-10.362.544z",
  strokeLinejoin: "round"
}));

var SvgTeddybear = function SvgTeddybear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeddybear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Teddy bear.8de5719b.svg";
export { ForwardRef as ReactComponent };